import moment from 'moment-timezone';

import dateAndTimeConstants from 'utils/dateAndTimes/constants';
import dateAndTimeMethods from 'utils/dateAndTimes/methods';

const getRules = (times, isForSuggestions = { times: false, dates: false }) => {
  const timesJoined = dateAndTimeMethods.joinTimesWithDates(times);

  const {
    pickup_date_from: pickupDateFrom,
    dropoff_date_from: dropoffDateFrom,
  } = times;

  const {
    pickup_time_from: pickupTimeFrom,
    pickup_time_to: pickupTimeTo,
    dropoff_time_from: dropoffTimeFrom,
    isToday,
  } = timesJoined;

  const nowMomentPickup = moment()
    .tz(times.pickup_timezone || moment.tz.guess())
    .clone();
  const nowMomentDropoff = moment()
    .tz(times.dropoff_timezone || moment.tz.guess())
    .clone();

  const pickupTimeFromMoment = moment(pickupTimeFrom).clone();
  const pickupDateFromMoment = moment(pickupDateFrom)
    .tz(times.pickup_timezone || moment.tz.guess())
    .clone();

  const pickupTimeToMoment = moment(pickupTimeTo).clone();
  const dropoffTimeFromMoment = moment(dropoffTimeFrom)
    .tz(times.dropoff_timezone || moment.tz.guess())
    .clone();

  const dropoffDateFromMoment = dropoffDateFrom
    ? moment(new Date(dropoffDateFrom))
        .tz(times.dropoff_timezone || moment.tz.guess())
        .clone()
    : nowMomentDropoff.clone();

  if (
    isToday &&
    dateAndTimeMethods.canBeToday(times.pickup_timezone || moment.tz.guess())
  ) {
    return {
      pickup_time_from: {
        min: {
          value: nowMomentPickup
            .clone()
            .add(
              dateAndTimeConstants.CONSTANTS_FOR_RULES
                .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
              'hour'
            ),
          error: 'MIN_pickup_time_from_TODAY',
        },
        max: {
          value: nowMomentPickup.clone().endOf('day'),
          error: 'MAX_pickup_time_from_TODAY',
        },
      },
      pickup_time_to: {
        min: {
          value: pickupTimeFrom
            ? moment.max(
                pickupTimeFromMoment,
                nowMomentPickup
                  .clone()
                  .add(
                    dateAndTimeConstants.CONSTANTS_FOR_RULES
                      .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
                    'hour'
                  )
              )
            : nowMomentPickup
                .clone()
                .add(
                  dateAndTimeConstants.CONSTANTS_FOR_RULES
                    .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
                  'hour'
                ),

          error: 'MIN_pickup_time_to_TODAY',
        },
        max: {
          value: pickupTimeFrom
            ? pickupTimeFromMoment
                .clone()
                .add(
                  dateAndTimeConstants.CONSTANTS_FOR_RULES
                    .MAX_STOP_DURATION_IN_HOURS,
                  'hours'
                )
            : nowMomentPickup.clone().endOf('day'),
          error: 'MAX_pickup_time_to_TODAY',
        },
      },
      dropoff_time_from: {
        min: {
          value: isForSuggestions.times
            ? moment.max(
                pickupTimeFromMoment,

                nowMomentDropoff
                  .clone()
                  .add(
                    dateAndTimeConstants.CONSTANTS_FOR_RULES
                      .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
                    'hour'
                  ),
                dropoffDateFromMoment.clone().startOf('day')
              )
            : pickupTimeFrom
            ? moment.max(
                pickupTimeFromMoment,
                nowMomentDropoff
                  .clone()
                  .add(
                    dateAndTimeConstants.CONSTANTS_FOR_RULES
                      .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
                    'hour'
                  )
              )
            : moment.max(
                nowMomentDropoff
                  .clone()
                  .add(
                    dateAndTimeConstants.CONSTANTS_FOR_RULES
                      .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
                    'hour'
                  ),
                dropoffDateFromMoment.clone().startOf('day')
              ),
          error: 'MIN_dropoff_time_from_TODAY',
        },
        max: {
          value: isForSuggestions.times
            ? dropoffDateFromMoment.clone().endOf('day')
            : nowMomentDropoff
                .clone()
                .add(
                  dateAndTimeConstants.CONSTANTS_FOR_RULES
                    .MAX_DIFFERENCE_BETWEEN_PICKUP_AND_DROPOFF_IN_DAYS,
                  'days'
                )
                .endOf('day'),
          error: 'MAX_dropoff_time_from_TODAY',
        },
      },
      dropoff_time_to: {
        min: {
          value: moment.max(
            pickupTimeToMoment.clone(),
            pickupTimeFromMoment.clone(),
            dropoffTimeFromMoment.clone(),
            dropoffDateFromMoment.clone().startOf('day'),
            nowMomentDropoff
              .clone()
              .add(
                dateAndTimeConstants.CONSTANTS_FOR_RULES
                  .MIN_MARGIN_BEFORE_PICKUP_IN_HOURS,
                'hour'
              )
          ),
          error: 'MIN_dropoff_time_to_TODAY',
        },
        max: {
          value: isForSuggestions.times
            ? dropoffDateFromMoment
                .clone()
                .endOf('day')
                .add(
                  dateAndTimeConstants.CONSTANTS_FOR_RULES
                    .MAX_STOP_DURATION_IN_HOURS,
                  'hour'
                )
            : dropoffTimeFrom
            ? dropoffTimeFromMoment
                .clone()
                .add(
                  dateAndTimeConstants.CONSTANTS_FOR_RULES
                    .MAX_STOP_DURATION_IN_HOURS,
                  'hour'
                )
            : nowMomentDropoff
                .clone()
                .add(
                  dateAndTimeConstants.CONSTANTS_FOR_RULES
                    .MAX_DIFFERENCE_BETWEEN_PICKUP_AND_DROPOFF_IN_DAYS,
                  'days'
                )
                .endOf('day'),
          error: 'MAX_dropoff_time_to_TODAY',
        },
      },
    };
  }

  return {
    pickup_time_from: {
      min: {
        value: pickupDateFromMoment.clone().startOf('day'),
        error: 'MIN_pickup_time_from_OTHER_DAY',
      },
      max: {
        value: pickupDateFromMoment.clone().endOf('day'),
        error: 'MAX_pickup_time_from_OTHER_DAY',
      },
    },
    pickup_time_to: {
      min: {
        value: pickupTimeFrom
          ? pickupTimeFromMoment.clone()
          : pickupDateFromMoment.clone().startOf('day'),
        error: 'MIN_pickup_time_to_OTHER_DAY',
      },
      max: {
        value: pickupTimeFrom
          ? pickupTimeFromMoment
              .clone()
              .add(
                dateAndTimeConstants.CONSTANTS_FOR_RULES
                  .MAX_STOP_DURATION_IN_HOURS,
                'hours'
              )
          : pickupDateFromMoment.clone().endOf('day'),
        error: 'MAX_pickup_time_to_OTHER_DAY',
      },
    },
    dropoff_time_from: {
      min: {
        value: isForSuggestions.dates
          ? pickupDateFromMoment.clone().startOf('day')
          : pickupTimeFrom
          ? moment.max(
              pickupTimeFromMoment.clone(),
              dropoffDateFromMoment.clone().startOf('day')
            )
          : moment.max(
              pickupDateFromMoment.clone().startOf('day'),
              dropoffDateFromMoment.clone().startOf('day')
            ),
        error: 'MIN_dropoff_time_from_OTHER_DAY',
      },
      max: {
        value: isForSuggestions.dates
          ? pickupDateFromMoment
              .clone()
              .add(
                dateAndTimeConstants.CONSTANTS_FOR_RULES
                  .MAX_DIFFERENCE_BETWEEN_PICKUP_AND_DROPOFF_IN_DAYS,
                'days'
              )
              .endOf('day')
          : isForSuggestions.times
          ? dropoffDateFromMoment.clone().endOf('day')
          : moment.min(
              dropoffDateFromMoment.clone().endOf('day'),
              pickupDateFromMoment
                .clone()
                .add(
                  dateAndTimeConstants.CONSTANTS_FOR_RULES
                    .MAX_DIFFERENCE_BETWEEN_PICKUP_AND_DROPOFF_IN_DAYS,
                  'days'
                )
                .endOf('day')
            ),
        error: 'MAX_dropoff_time_from_OTHER_DAY',
      },
    },
    dropoff_time_to: {
      min: {
        value: moment.max(
          pickupTimeToMoment
            .clone()
            .add(
              dateAndTimeConstants.CONSTANTS_FOR_RULES
                .MIN_MARGIN_BEFORE_DROPOFF_IN_HOURS,
              'hours'
            ),
          pickupTimeFromMoment.clone(),
          dropoffTimeFromMoment.clone(),
          pickupDateFromMoment.clone().startOf('day'),
          dropoffDateFromMoment.clone().startOf('day')
        ),
        error: 'MIN_dropoff_time_to_OTHER_DAY',
      },
      max: {
        value: dropoffTimeFrom
          ? dropoffTimeFromMoment
              .clone()
              .add(
                dateAndTimeConstants.CONSTANTS_FOR_RULES
                  .MAX_STOP_DURATION_IN_HOURS,
                'hour'
              )
          : dropoffDateFrom
          ? dropoffDateFromMoment
              .endOf('day')
              .add(
                dateAndTimeConstants.CONSTANTS_FOR_RULES
                  .MAX_STOP_DURATION_IN_HOURS,
                'hour'
              )
              .clone()
          : pickupTimeTo
          ? pickupTimeToMoment
              .clone()
              .add(
                dateAndTimeConstants.CONSTANTS_FOR_RULES
                  .MAX_DIFFERENCE_BETWEEN_PICKUP_AND_DROPOFF_IN_DAYS,
                'days'
              )
              .endOf('day')
          : pickupDateFromMoment
              .clone()
              .add(
                dateAndTimeConstants.CONSTANTS_FOR_RULES
                  .MAX_DIFFERENCE_BETWEEN_PICKUP_AND_DROPOFF_IN_DAYS,
                'days'
              )
              .endOf('day'),
        error: 'MAX_dropoff_time_to_OTHER_DAY',
      },
    },
  };
};

export default getRules;
